export const DASHBOARD_ROUTE = "DASHBOARD_ROUTE";
export const LOGIN_ROUTE = "LOGIN_ROUTE";
export const SIGNUP_ROUTE = "SIGNUP_ROUTE";
export const FORGOT_PASSWORD_ROUTE = "FORGOT_PASSWORD_ROUTE";
// Reset password from the "forgot password" email link.
export const RESET_PASSWORD_ROUTE = "RESET_PASSWORD_ROUTE";
// Staff invite: set initial password and verify email.
export const SET_PASSWORD_ROUTE = "SET_PASSWORD_ROUTE";

export const VERIFICATIONS_ROUTE = "VERIFICATIONS_ROUTE";
export const ACCOUNTS_ROUTE = "ACCOUNTS_ROUTE";
// Platform account detail page (overview / verifications / subscription / settings).
export const ACCOUNT_DETAIL_ROUTE = "ACCOUNT_DETAIL_ROUTE";
export const BANK_ACCOUNTS_ROUTE = "BANK_ACCOUNTS_ROUTE";
export const SUBSCRIPTION_ROUTE = "SUBSCRIPTION_ROUTE";
export const SUBSCRIPTION_PLANS_ROUTE = "SUBSCRIPTION_PLANS_ROUTE";
export const PAYMENTS_ROUTE = "PAYMENTS_ROUTE";
// Public Chapa payment callback / confirmation page.
export const PAYMENT_CONFIRMATION_ROUTE = "PAYMENT_CONFIRMATION_ROUTE";
// Legacy alias for the previous Chapa return url (kept for in-flight payments).
export const SUBSCRIPTION_VERIFY_ROUTE = "SUBSCRIPTION_VERIFY_ROUTE";
export const SETTINGS_ROUTE = "SETTINGS_ROUTE";
